export const LearningJourneyContentCardQuestions = [
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "The knowledge and skills shared were relevant and useful.",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "1. Strong Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "2. Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "3. Neutral",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "4. Agree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "5. Strong Agree",
                "isOther": false
            },
        ],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "The amount of material presented in this programme was just right.",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "1. Strong Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "2. Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "3. Neutral",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "4. Agree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "5. Strong Agree",
                "isOther": false
            },
        ],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Which part of the Learning Journey did you enjoy the most?",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Which part of the Learning Journey do you think could be improved?",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "What other areas would you have liked to be covered?",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "What other comments or suggestions do you have for this Learning Journey?",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
]